import { render, staticRenderFns } from "./MachineProductForm.vue?vue&type=template&id=0b403f64&scoped=true&"
import script from "./MachineProductForm.vue?vue&type=script&lang=js&"
export * from "./MachineProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b403f64",
  null
  
)

export default component.exports